import React from 'react';

export interface AppAutocompleteWithActionsProps<T> {
  name: string;
  control: any;
  label: any;
  options: T[];
  selectedList?: T[];
  validationProps?: ValidationProps;
  itemActionHandler?: (value: any, type: CrudActionEnum) => void;
  onChange?: (value: T[]) => void;
  placeholder?: string;
  language?: string;
  multiple?: boolean;
  disabled?: boolean;
}

interface IErrorMessage {
  [fieldName: string]: {
    [errorType: string]: string;
  };
}

export interface ValidationProps {
  errors?: any;
  errorMessages?: IErrorMessage;
  validationRules?: any;
  getErrorMessage?: any;
}

export interface AppAutocompleteV2Props<T> {
  name: string;
  language?: string;
  control: any;
  label: any;
  options: T[];
  withChip?: boolean;
  multiple?: boolean;
  selectedList?: T[];
  validationProps?: ValidationProps;
  placeholder?: string;
  onItemSelect?: (value: T) => void;
  disabled?: boolean;
  allowAddOnEnter?: boolean;
  clearMessage?: string;
  addItemConfig?: {
    action?: CrudActionEnum | '';
    callback?: (data: { title: string }) => void;
  };
  renderOptionBadge?: (option: T) => React.ReactNode;
  loading?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

export enum CrudActionEnum {
  Edit = 'edit',
  Add = 'add',
  AddWithDialog = 'addWithDialog',
  Delete = 'delete'
}
